// Logos white-label (versão para fundo claro) por trecho do domínio.
// Fonte única usada pelo cabeçalho das consultas (HeaderQuery) e pelo
// "Salvar PDF" — o PDF é renderizado no painel principal em headless, onde o
// domínio do cliente não existe, então o caminho da logo precisa ser enviado
// por quem dispara o download.
const PDF_LOGOS_BY_HOST = [
  ["avaliecreditoconsultas", "/assets/white-label/avalie-credito/logo.png"],
  ["acessopositivo", "/assets/white-label/acesso-positivo/logo-azul.png"],
  ["proconsultbr", "/assets/white-label/pro-consult-br/logo_consult.png"],
  ["simscore", "/assets/white-label/sim-pesquisa/logo_sim.png"],
  ["simpesquisa", "/assets/white-label/sim-pesquisa/logo_sim.png"],
  ["credoresbrasil", "/assets/white-label/credores-brasil/logo.png"],
  ["consultaspositivo", "/assets/white-label/consultas-positivo/logo.png"],
  ["raioxconsultas", "/assets/white-label/raio-x/logo.png"],
  ["obahcredito", "/assets/white-label/obah-credito/logo.png"],
  ["hellusconsultoria", "/assets/white-label/hellus-consultoria/logo.png"],
  ["nomenoazul", "/assets/white-label/nome-no-azul/logo.png"],
  ["finposcore", "/assets/white-label/finpo-score/logo.png"],
  ["locagora", "/assets/white-label/locagora/logo.png"],
  ["riscocred", "/assets/white-label/riscocred/logo.png"],
  ["ampliacapital", "/assets/white-label/amplia-capital/logo.png"],
  ["periciadecredito", "/assets/white-label/pericia-de-credito/logo.png"],
  ["meuraioxdecredito", "/assets/white-label/raiox-de-credito/logo.png"],
  ["solucoesmoura", "/assets/white-label/solucoes-moura/logo.png"],
];

export const DEFAULT_PDF_LOGO = "/assets/relinq_1.png";

export const getPdfLogoPath = (
  href = typeof window !== "undefined" ? window.location.href : "",
) => {
  const match = PDF_LOGOS_BY_HOST.find(([token]) => href.includes(token));
  return match ? match[1] : DEFAULT_PDF_LOGO;
};
